import type { AxiosInstance } from "axios";

export interface UserEnrichmentRequestsQuery {
  readonly page?: number;
  readonly limit?: number;
}

export interface TriggerUserEnrichmentPayload {
  readonly participantIdsPublic?: readonly string[];
  readonly userEnrichmentRequestIdsPublic?: readonly string[];
}

const USER_ENRICHMENT_BASE = "/api/v1/admin/enrichment/user";
const REQUESTS_API_PATH = `${USER_ENRICHMENT_BASE}/requests`;
const TRIGGER_API_PATH = `${USER_ENRICHMENT_BASE}/trigger`;

export function createUserEnrichmentAdminApi(apiClient: AxiosInstance) {
  return {
    async getRequests(
      query: UserEnrichmentRequestsQuery = {},
    ): Promise<unknown> {
      const response = await apiClient.get(REQUESTS_API_PATH, {
        params: {
          ...(query.page !== undefined && { page: query.page }),
          ...(query.limit !== undefined && { limit: query.limit }),
        },
      });
      return response.data;
    },

    async getRequest(idPublic: string): Promise<unknown> {
      const response = await apiClient.get(
        `${REQUESTS_API_PATH}/${encodeURIComponent(idPublic)}`,
      );
      return response.data;
    },

    async getEnrichedData(idPublic: string): Promise<unknown> {
      const response = await apiClient.get(
        `${USER_ENRICHMENT_BASE}/${encodeURIComponent(idPublic)}`,
      );
      return response.data;
    },

    async trigger(
      payload: TriggerUserEnrichmentPayload,
    ): Promise<readonly unknown[]> {
      const response = await apiClient.put<readonly unknown[]>(
        TRIGGER_API_PATH,
        {
          ...(payload.participantIdsPublic !== undefined && {
            participantIdsPublic: payload.participantIdsPublic,
          }),
          ...(payload.userEnrichmentRequestIdsPublic !== undefined && {
            userEnrichmentRequestIdsPublic:
              payload.userEnrichmentRequestIdsPublic,
          }),
        },
      );
      return response.data;
    },
  };
}
